import React, { useContext, useEffect, useState } from "react";
import useLogout from "components/common/useLogout";
import { useHistory } from "react-router-dom";
import { restoreDelegateUser } from "services/companyServices";
import * as userService from "services/userServices";
import { UserContext } from "components/context/UserContext";
import GenericModal from "components/common/GenericModal";
import { ICONS } from "components/common/constants/swal.constants";

const DelegateAuthLostModal: React.FC = () => {
  const [open, setOpen] = useState(false);
  const logout = useLogout("/login", undefined, undefined, () =>
    setOpen(false)
  );
  const history = useHistory();
  const { state, dispatch } = useContext(UserContext)!;

  // Only attach listener for delegate users (roleId === 8)
  useEffect(() => {
    if (state.currentUser?.roleId !== 8) return;

    const handler = () => setOpen(true);
    window.addEventListener("delegate-auth-lost", handler);
    return () => window.removeEventListener("delegate-auth-lost", handler);
  }, [state.currentUser?.roleId]);

  if (!open) return null;

  const handleReturnToDelegateDashboard = async () => {
    try {
      const res = await restoreDelegateUser();

      if (!res.isSuccessful) {
        logout();
        return;
      }
      setOpen(false);
      history.push("/impersonation-options");
    } catch (e) {
      logout();
    }
  };

  return (
    <GenericModal
      show={open}
      onHide={() => setOpen(false)}
      title="Session problem"
      subtext="Your delegate session is no longer valid. You can return to your delegate dashboard or log out."
      icon={ICONS.error}
      btnText="Log out"
      onBtnClick={logout}
      proceedBtnText="Delegate dashboard"
      onProceedBtnClick={handleReturnToDelegateDashboard}
    />
  );
};

export default DelegateAuthLostModal;
